import Customers from './customers/index.js'
import Settings from './settings/index.js'
import GiftsAndBundleServices from './gifts-and-bundle-services.js'
import Promotion from './promotion/index.js'
import StatsAndReports from './stats-and-reports.js'
import Sales from './sales.js'
import Inventory from './inventory/index.js'
import InventoryMobile from './inventory/index-mobile.js'
import Profile from './profile.js'
import Playground from './playground.js'
import Staff from './staff.js'
import TurnTracker from './turn-tracker.js'
import BooksyWallet from './booksy-wallet.js'

import { store } from '@/store/index.js'
import { useEppo } from '@/composables/eppo/index.js'
import { FEATURE_FLAGS } from '@/lib/consts.js'

const Business = {
  path: '/:businessId(\\d+)',
  name: 'business',
  meta: {
    loginRequired: true,
    defaultSubroute: () => {
      const turnTrackerEnabled = useEppo().ff(FEATURE_FLAGS.Feature_TurnTracker)
        && store.state.business?.business?.turntracker_enabled

      const hasAccessToTurnTracker = store.getters['identity/isReceptionOrHigher']

      return (turnTrackerEnabled && hasAccessToTurnTracker)
        ? {
          name: 'turn-tracker',
        } : {
          name: 'calendar',
          params: {
            date: 'today',
          },
        }
    },
  },
  component: () => import('@/views/business/index.vue'),
  children: [
    {
      path: 'forbidden',
      name: 'forbidden',
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/403-forbidden.vue'),
    },
    {
      path: 'booksy-awards',
      name: 'booksy-awards',
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/booksy-awards.vue'),
    },
    {
      path: 'calendar',
      name: 'calendar-main',
      meta: {
        hintKey: ['hintFeatureCalendar', 'hintFeatureCalendarLive', 'hintRecommendationsCalendar'],
        defaultSubroute: {
          name: 'calendar',
        },
      },
      component: () => import('@/views/business/calendar/index.vue'),
      children: [
        {
          path: 'settings',
          name: 'calendar-settings',
          meta: {},
          component: () => import('@/views/business/calendar/settings.vue'),
        },
        {
          path: '',
          name: 'calendar',
          meta: {
            // enable toasts w/ notifications
            notifications: true,
          },
          component: () => import('@/views/business/calendar/calendar.vue'),
        },
      ],
    },
    {
      path: 'elearning',
      name: 'elearning',
      component: () => import('@/views/business/elearning.vue'),
    },
    {
      path: 'partner-app/:partnerType',
      name: 'partner-app',
      component: () => import('@/views/business/partner-app.vue'),
    },
    {
      path: 'staffer-blocked-info',
      name: 'staffer-blocked-info',
      meta: {
        hideSidebar: true,
      },
      component: () => import('@/views/business/staffer-blocked-info/index.vue'),
    },
    {
      name: 'reports',
      path: 'reports/:path(.*)?',
      redirect: { name: 'stats-and-reports' },
    },
    Sales,
    Customers,
    Inventory,
    InventoryMobile,
    Settings,
    GiftsAndBundleServices,
    Profile,
    Promotion,
    StatsAndReports,
    Staff,
    TurnTracker,
    BooksyWallet,
    ...(process.env.NODE_ENV === 'development' ? [Playground] : []),
  ],
}

export default Business
